export interface ConfigData {
  customerId: number;
  globalApiUrl: string;
  tenant: string;
}

class Config {
  private config: ConfigData | undefined;

  init(config: ConfigData): void {
    this.config = config;
  }

  get = (): ConfigData => {
    if (!this.config) {
      throw new Error('favorites provider configuration have not been initialized');
    }

    return this.config;
  };
}

const config = new Config();

export { config as Config };
